<template>
    <page-view>
        <template slot="action">
            <!--<a-button type="primary" :loading="saveLoading" @click="onSubmit">支付</a-button>-->
        </template>
        <a-card>
            <a-row>
                <a-col :span="10">
                    指定年月：
                    <a-month-picker format="YYYY-MM" v-model="appointYearMonth" placeholder="指定年月"/>
                    &nbsp;<a-button type="primary" @click="loadData">查询</a-button>
                </a-col>
            </a-row>
            <br/>
            <table class="fx-form-view">
                <!--<col width="120px"/>-->
                <!--<col/>-->
                <tr>
                    <th>年月</th>
                    <td colspan="5">{{appointYearMonth.format('YYYY年MM月')}}</td>
                </tr>
                <tr>
                    <th>总计项目数</th>
                    <td>{{info.allUseNumber}}</td>
                    <th>总计专家数(人)</th>
                    <td>{{info.allExpertNum}}</td>
                    <th>总计费用(元)</th>
                    <td><b>{{info.allSumFees}}</b></td>
                </tr>

            </table><br/>
            <div v-for="deptFees in info.statDeptFees" :key="deptFees.deptId">
                <table class="fx-form-view" >
                    <!--<col width="120px"/>-->
                    <!--<col/>-->
                    <tr>
                        <th >部门名称</th>
                        <td colspan="5" style="font-size: large">{{deptFees.deptName}}</td>
                    </tr>
                    <tr>
                        <th>项目数</th>
                        <td>{{deptFees.deptUseNumber}}</td>
                        <th>参与专家数(人)</th>
                        <td>{{deptFees.deptExpertNum}}</td>
                        <th>专家费总数(元)</th>
                        <td><b>{{deptFees.deptSumFees}}</b></td>
                    </tr>
                    <tr>
                        <th>专家姓名</th>
                        <th>参与次数</th>
                        <th>最高专家费(元)</th>
                        <th>最低专家费(元)</th>
                        <th>平均专家费(元)</th>
                        <th>专家费总数(元)</th>
                    </tr>
                    <tr v-for="expertFees in deptFees.statDeptExpertFees" :key="expertFees.expertId">
                        <td>{{expertFees.expertName}}</td>
                        <td>{{expertFees.deptExpertUseNumber}}</td>
                        <td>{{expertFees.deptExpertMaxFees}}</td>
                        <td>{{expertFees.deptExpertMinFees}}</td>
                        <td>{{expertFees.deptExpertAvgFees}}</td>
                        <td>{{expertFees.deptExpertSumFees}}</td>
                    </tr>
                </table><br/>
            </div>
        </a-card>
    </page-view>
</template>
<script>
import qs from 'qs'
import moment from 'moment'
import { PageView } from '@/layouts'

export default {
  name: 'expertFeesTable',
  components: {
    PageView
  },
  data () {
    return {
      info: [],
      appointYearMonth: moment().startOf('month')
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const data = {
        appointYearMonth: this.appointYearMonth.format('YYYY-MM')
      }
      const res = await this.$http.get('/api/1/expertmain/selectExpertFeedback/fees/stat_fees.json', { params: data })
      if (res.code !== 200) {
        return
      }
      this.info = res.result
      console.log(1, this.info)
    }
  }
}
</script>
<style lang="less" scoped>

    .fx-form-view {
    width: 100%;
    /*background-color: white;*/
    border-collapse: collapse;
    border: 1px solid #ccc;
    }

    .fx-form-view th {
    padding: 14px 8px 14px 10px;
    /*border: 1px solid #cde2fa;*/
    font-weight: normal;
    /*width: 120px;*/
    /*color: #444;*/
    /*background-color: #e9f8ff;*/
    height: 38px;
    }

    .fx-form-view td {
    padding: 14px 8px 14px 10px;
    /*border: 1px solid #cde2fa;*/
    //min-width: 100px;
    /*width: 180px;*/
    height: 38px;
    /*color: #444;*/
    }

</style>
